import { render, staticRenderFns } from "./immagineSfondo.vue?vue&type=template&id=634921b2&"
import script from "./immagineSfondo.vue?vue&type=script&lang=js&"
export * from "./immagineSfondo.vue?vue&type=script&lang=js&"
import style0 from "./immagineSfondo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports